import { reactive } from 'vue'

const state = reactive(new Map())

const eventBus = {
  on(event, callback) {
    if (!state.has(event)) {
      state.set(event, [])
    }
    state.get(event).push(callback)
  },
  off(event, callback) {
    if (state.has(event)) {
      const callbacks = state.get(event)
      if (callbacks) {
        const index = callbacks.indexOf(callback)
        if (index > -1) {
          callbacks.splice(index, 1)
        }
      }
    }
  },
  emit(event, data) {
    if (state.has(event)) {
      state.get(event).forEach(callback => callback(data))
    }
  }
}

export default eventBus
